// src/mocks/handlers.js
import { HttpResponse, graphql, http } from 'msw'
import { apiBase } from '../utils/base-url'
import { fixedCargoMock, openCargoMock, subsCargoMock } from './mock-data/cargo'
import { mockComments } from './mock-data/comments'
import { dashboardSummaryMockData } from './mock-data/dashboard/summary'
import { mockExposure, mockTotalExposure } from './mock-data/exposure'
import { forecastComments } from './mock-data/forecast-comments'
import { poolPartnerList } from './mock-data/list/pool-partner-list'
import { vesselsList } from './mock-data/list/vessels-list'
import { dummyUserVt } from './mock-data/me/me-vt'
import { notificationBannerMock } from './mock-data/notification-banner'
import { poolsMock } from './mock-data/pools'
import {
  positionListMock,
  positionListStatusMock,
} from './mock-data/position-list'
import { mockPreFixture } from './mock-data/pre-fixture/mock-pre-fixture'
import { reportTypeMock, reportWithIdMock } from './mock-data/reports'
import { mockUsers } from './mock-data/users'
import { dummyVessel } from './mock-data/vessels'
import { mockGeneralInfo } from './mock-data/vessels/general-info'
import { patchVesselsStatusResMock } from './mock-data/vessels/patch-vessels-res'
import { postVesselsResMock } from './mock-data/vessels/post-vessels-res'

export const handlers = [
  http.get(`${apiBase()}/prefixture/:preFixtureId`, () => {
    return HttpResponse.json(mockPreFixture, { status: 200 })
  }),
  http.get(`${apiBase()}/users`, () => {
    return HttpResponse.json(mockUsers, { status: 200 })
  }),
  http.get(`${apiBase()}/positionlist/status`, () => {
    return HttpResponse.json(positionListStatusMock, { status: 200 })
  }),
  http.get(`${apiBase()}/positionlist/commercialmanagementvessels`, () => {
    return HttpResponse.json([], { status: 200 })
  }),
  http.get(`${apiBase()}/positionlist/vessels`, () => {
    return HttpResponse.json(positionListMock, { status: 200 })
  }),
  http.get(`${apiBase()}/vessels/:vessel/general-info`, () => {
    return HttpResponse.json(mockGeneralInfo, { status: 200 })
  }),
  http.get(`${apiBase()}/reports`, ({ request }) => {
    const url = new URL(request.url)
    const type = url.searchParams.get('type')
    const reportId = url.searchParams.get('reportId')
    const includeEmbedToken = url.searchParams.get('includeEmbedToken')

    if (type === 'euets-report') {
      return HttpResponse.json(reportTypeMock, { status: 200 })
    }

    if (reportId && includeEmbedToken === 'true') {
      return HttpResponse.json(reportWithIdMock, { status: 200 })
    }
  }),
  http.get(`${apiBase()}/me`, () => {
    return HttpResponse.json(dummyUserVt, { status: 200 })
  }),
  http.patch(`${apiBase()}/me`, () => {
    return HttpResponse.json({ status: 200 })
  }),
  http.get(`${apiBase()}/vessels`, () => {
    return HttpResponse.json([dummyVessel], { status: 200 })
  }),
  http.get(`${apiBase()}/posts`, () => {
    return HttpResponse.json(forecastComments, { status: 200 })
  }),
  http.get(`${apiBase()}/pools`, () => {
    return HttpResponse.json(poolsMock, { status: 200 })
  }),
  // http.get('https://maersktankers-stage.digital/api/marketing/signups', () => {
  //   return HttpResponse.json(testResponse, { status: 200 })
  // }),
  http.get(`${apiBase()}/dashboard/summary`, () => {
    return HttpResponse.json(dashboardSummaryMockData, { status: 200 })
  }),
  http.get(`${apiBase()}/pools/:poolName/comments`, () => {
    return HttpResponse.json(mockComments, { status: 200 })
  }),
  // http.get(`${apiBase()}/forecast/calculated?pool=:poolName`, () => {
  //   return HttpResponse.json(mockForecast, { status: 200 })
  // }),

  graphql.query('getMTOpenVessels', () => {
    return HttpResponse.json(mockExposure)
  }),
  graphql.query('GetMTOpenVessels2', () => {
    return HttpResponse.json(mockTotalExposure)
  }),
  http.post(`${apiBase()}/vessels`, () => {
    return HttpResponse.json(postVesselsResMock, { status: 200 })
  }),
  http.patch(`${apiBase()}/vessels/:vesselId/status`, () => {
    return HttpResponse.json(patchVesselsStatusResMock, { status: 200 })
  }),
  http.get(`${apiBase()}/q88/list`, () => {
    return HttpResponse.json(vesselsList, { status: 200 })
  }),
  http.get(`${apiBase()}/poolpartners/list`, () => {
    return HttpResponse.json(poolPartnerList, { status: 200 })
  }),
  http.get(`${apiBase()}/notification/banners`, () => {
    return HttpResponse.json(notificationBannerMock, { status: 200 })
  }),
  http.get(`${apiBase()}/cargo/cargo-grades`, () => {
    return HttpResponse.json(['CPP', 'DPP'], { status: 200 })
  }),
  http.get(`${apiBase()}/cargo`, ({ request }) => {
    const url = new URL(request.url)
    const status = url.searchParams.get('status')

    if (status === 'Open') {
      return HttpResponse.json([openCargoMock], { status: 200 })
    }

    if (status === 'On Subs') {
      return HttpResponse.json([subsCargoMock], { status: 200 })
    }
    if (status === 'Fixed') {
      return HttpResponse.json([fixedCargoMock], { status: 200 })
    }
  }),

  http.get(`${apiBase()}/cargo/:cargoId`, () => {
    return HttpResponse.json(openCargoMock, { status: 200 })
  }),
]
